import { createSlice } from "@reduxjs/toolkit";
import { bookMarkData } from "../../Data/LayoutData/HeaderData";
import { UserType } from "../../Types/Auth/UserType";
const initialState: UserType = {
  firstname: "",
  lastname: "",
  email: "",
  role : "USER",
  loggedIn: false,
  phonenumber: "",
  active_pages_limit: 1,
  patient_count: 0,
  expire_date: null,
  report_count: 0,
  total_views: 0
};

const UserSlice = createSlice({
  name: "UserSlice",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.firstname = action.payload.firstname || state.firstname;
      state.lastname = action.payload.lastname || state.lastname;
      state.email = action.payload.email || state.email;
      state.loggedIn = true;
      state.role = action.payload.role || state.role;
      state.phonenumber = action.payload.phonenumber || state.phonenumber;
      state.patient_count = action.payload.patient_count || state.patient_count
      state.report_count = action.payload.report_count || state.report_count
      state.total_views = action.payload.total_views || state.total_views
    },
    removeUser: (state) => {
      state.firstname = ""
      state.lastname = ""
      state.email = ""
      state.role = "USER"
      state.phonenumber = ""
      state.loggedIn = false
      state.patient_count = 0;
      state.report_count = 0
      state.total_views = 0
    }
  },
});

export const { setUser, removeUser } = UserSlice.actions;

export default UserSlice.reducer;